import { compose } from "lodash/fp";

import ConnectWithAgentCTABase from "./components/ConnectWithAgentCTA";
import ExpertsMatchDrawerBase from "./components/ExpertMatchDrawer";
import store from "./redux/store";
import withInitialization from "./redux/utilities/withInitialization";
import withReduxProvider from "./redux/utilities/withReduxProvider";

const enhance = compose(
  withInitialization(store),
  withReduxProvider(store)
);

const ConnectWithAgentCTA = withReduxProvider(store)(ConnectWithAgentCTABase);
const ExpertsMatchDrawer = enhance(ExpertsMatchDrawerBase);

export { ConnectWithAgentCTA, ExpertsMatchDrawer };
